<div class="div-menu-alterno" [routerLink]="['/']">
    <div class="div-img-titulo-menu-alterno">
        <div class="div-menu-alterno-p1"><img
                src="/estadisticas-economicas/assets/img/iconos/estadisticas-graficas-interactivas.svg"
                class="img-boton-inicio" alt="ícono gráfica" title="gráfica"></div>
        <div>
            <div><span class="texto-retornar">Retornar a</span></div>
            <div><span class="texto-estadisticas-economicas">{{constantes.ETIQUETA_BOTON_APLICACION}}</span></div>
        </div>
    </div>
</div>